import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { formatter } from "@/shared/ts/formatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeGuidanceSummary',
  props: {
    suggestedAmountOnPlsaDate: { type: Number, default: 0 },
    suggestedAmountAtRetirement: { type: Number, default: 0 },
    incomeSetupMode: { type: Boolean, required: true }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.incomeSetupMode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _cache[0] || (_cache[0] = _createTextVNode(" Based on your answers, the ")),
          _cache[1] || (_cache[1] = _createElementVNode("a", {
            href: "https://www.retirementlivingstandards.org.uk",
            target: "_blank",
            title: "Retirement Living Standards"
          }, "Retirement Living Standards", -1)),
          _cache[2] || (_cache[2] = _createTextVNode(" or ")),
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            href: "https://www.livingwage.org.uk/what-real-living-wage",
            target: "_blank",
            title: "Living wage"
          }, "Living wage", -1)),
          _createTextVNode(" suggest an after tax income if you retired in 2025 of " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountOnPlsaDate)) + " for one person. We have increased that by 2.5% per year to when you want to retire in the box below. You can change this in the box below if you want to target more or less than the answer given. ", 1)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _cache[4] || (_cache[4] = _createTextVNode(" Based on your answers, the ")),
          _cache[5] || (_cache[5] = _createElementVNode("a", {
            href: "https://www.retirementlivingstandards.org.uk",
            target: "_blank",
            title: "Retirement Living Standards"
          }, "Retirement Living Standards", -1)),
          _cache[6] || (_cache[6] = _createTextVNode(" or ")),
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            href: "https://www.livingwage.org.uk/what-real-living-wage",
            target: "_blank",
            title: "Living wage"
          }, "Living wage", -1)),
          _createTextVNode(" suggest an after tax income if you retired in 2025 of " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountOnPlsaDate)) + " for one person. Increasing that by 2.5% per year to when you want to retire is " + _toDisplayString(_unref(formatter).formatCurrency(__props.suggestedAmountAtRetirement)), 1)
        ])),
    _cache[8] || (_cache[8] = _createElementVNode("p", null, [
      _createTextVNode(" If you'd like to work out your income and spending in more detail, you can use "),
      _createElementVNode("a", {
        href: "https://www.moneyhelper.org.uk/en/everyday-money/budgeting/budget-planner",
        target: "_blank"
      }, "Moneyhelper's budgeting tool"),
      _createTextVNode(". ")
    ], -1))
  ], 64))
}
}

})